import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { makeStyles } from '@mui/styles';

export const TableModule = (props) => {

    const { columns, rows, styles } = props;

    return (  
        <TableContainer style={{ ...styles }}>
            <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ minWidth: column.minWidth, fontWeight: 'bold' }}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                
                <TableBody>
                    { rows.length > 0 &&
                        rows.map((row, index) => {
                            return (
                                <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={index}
                                >
                                    {columns.map((column) => {
                                        let value;
                                        
                                        // Datos columna #
                                        if(column.id === 'count') {
                                            value = (index + 1);
                                        }else {
                                            value = row[column.id];
                                        }
                                        
                                        return (
                                            <TableCell
                                                key={column.id}
                                                align={column.align}
                                            >
                                                { value }
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        }) }
                </TableBody>
            </Table>

            { rows.length <= 0 && <NotMoreData /> }
        </TableContainer>
    );
}

TableModule.defaultProps = {
    styles: {},
    total: -1
}

const NotMoreData = () => {

    const classes = useStyles();

    return (
        <div className={classes.containerIntersection}>
            No hay más información
        </div>
    )
}

const useStyles = makeStyles({
    containerIntersection: {
        height: 50, 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        fontSize: 14,
        fontWeight: 500,
        color: '#494949'
    }
});